// The shared MOTION TUNING, so the three things that travel feel like one system: ../surface (LATERAL — peers
// side by side, a tab strip or the section pager), ../stack (HIERARCHICAL — levels, a list and the item it
// opens, which is where `parallax` is the depth cue) and the bottom sheet in lib/spring-travel.ts.
// Nothing here knows about routes, panes or the DOM.

export const TRANSITION_CONFIG = {
  /** Fraction of the surface width past which a release commits (below it, springs back). */
  commitThreshold: 0.4,
  // The HIERARCHICAL depth cue: how far the layer underneath trails the one on top.
  parallax: 0.28,
  /** Release speed (px/ms) in the commit direction that commits regardless of how far the drag got. */
  flickVelocity: 0.5,
  // Stiff and slightly UNDER-damped (ζ≈0.85), so it arrives fast with no soft tail.
  spring: { stiffness: 260, damping: 27, mass: 1 },
} as const
